module.exports = __webpack_public_path__ + "static/Broadway Musical_Easy-Resize.com-88782241d1a5e98b76798c857cf7b9c0.jpg";